import React from 'react'
import { Link } from 'react-router-dom'
import { injectIntl } from 'react-intl'

import LanguageControllerContainer from 'modules/Controllers/Language/LanguageControllerContainer'
import APPURL from 'utils/app/urls'
import RegionTools from 'utils/regions/regionTools'
import Config from 'utils/config'


const openMenuOffCanvas = event => {
  document.getElementsByTagName('html')[0].classList.add('ork-menu-off-canvas-open')
  event.preventDefault()
}

const Header = props => {
  const {
    intl: { formatMessage }
  } = props

  this.formatMessage = formatMessage

  const path = props.history.location.pathname
  const layer = APPURL.getLayerFromURL(path)
  const language = props.match.params.lang
  let homeLink = Config.getConfig().site.path + '/' + language
  const facebookLink = 'https://www.facebook.com/OrkestraIVC'
  const twitterLink = 'https://twitter.com/orkestra'
  const linkedinLink = 'https://www.linkedin.com/company/orkestra-basque-institute-of-competitiveness/'
  const youtubeLink = 'https://www.youtube.com/channel/UCwmbDDFEzX1Dg37jSz-Bi3g'
  const slideshareLink = 'https://es.slideshare.net/OrkestraIVC'
  const orkestraLink = 'https://www.orkestra.deusto.es/'

  const BASE_URL = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_PRODUCTION_HEAD : ''

  let selectedRegionName = ''
  if (props.regionsData) {
    selectedRegionName = RegionTools.getRegionNameFromId({ regionsData: props.regionsData, id: props.selectedRegionId })
  }

  let classHome
  let imgSrc
  if (layer === 0) {
    classHome = 'ork-header--home'
    imgSrc = BASE_URL + '/img/logo-observatorio-competitividad-dos-lineas-' + language + '.svg'
  } else if ( !Config.getProperty( "enable_region_change", true ) ) {
    classHome = 'ork-header--home'
    imgSrc = BASE_URL + '/img/logo-observatorio-competitividad-eustat-2-' + language + '.svg'
    homeLink = homeLink + "/ES21"
  } else {
    classHome = ''
    imgSrc = BASE_URL + '/img/logo-observatorio-competitividad-' + language + '.svg'
  }

  return (
    <header className={`container-fluid ork-header ${classHome}`}>
      <div className="row">
        <div className="col-md-6 col-lg-7 ork-header__left-block-wrapper">
          <div className="ork-header__left-block">
            <div className="ork-header__logo-wrapper">
              <Link to={homeLink}>
                <img src={imgSrc} alt="Observatorio de competitividad" className="ork-header__logo" />
              </Link>
            </div>
            <div className="ork-header__region-wrapper">
              <span className="ork-header__region" dangerouslySetInnerHTML={{ __html: selectedRegionName }} />
            </div>
            <span className="js-show-menu ork-burger-menu visible-xs-inline visible-sm-inline" onClick={openMenuOffCanvas}>
              <i className="fal fa-bars" />
            </span>
          </div>
        </div>
        <div className="hidden-xs hidden-sm col-md-6 col-lg-5 clearfix">
          <div className="ork-header__right-block clearfix">
            <ul className="ork-header__social-media clearfix">
              <li>
                <a href={facebookLink} target="_blank" rel="noopener noreferrer">
                  <img src={BASE_URL + '/img/icono-facebook.svg'} alt="Facebook" />
                </a>
              </li>
              <li>
                <a href={twitterLink} target="_blank" rel="noopener noreferrer">
                  <img src={BASE_URL + '/img/icono-twitter.svg'} alt="Twitter" />
                </a>
              </li>
              <li>
                <a href={linkedinLink} target="_blank" rel="noopener noreferrer">
                  <img src={BASE_URL + '/img/icono-linkedin.svg'} alt="LinkedIn" />
                </a>
              </li>
              <li>
                <a href={youtubeLink} target="_blank" rel="noopener noreferrer">
                  <img src={BASE_URL + '/img/icono-youtube.svg'} alt="Youtube" />
                </a>
              </li>
              <li>
                <a href={slideshareLink} target="_blank" rel="noopener noreferrer">
                  <img src={BASE_URL + '/img/icono-slideshare.svg'} alt="SlideShare" />
                </a>
              </li>
            </ul>
            <div className="ork-header__languages">
              <LanguageControllerContainer responsive={false} />
            </div>
            <div className="ork-header__logo-orkestra">
              <a href={orkestraLink} target="_blank" rel="noopener noreferrer">
                <img src={BASE_URL + '/img/logo-orkestra.svg'} alt="Orkestra: Instituto Vasco de Competitividad (Fundación Deusto)" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </header>
  )
}

export default injectIntl(Header)



// WEBPACK FOOTER //
// ./src/components/Header/Header.js